<template>
  <v-btn text :small="small" :aria-label="`Retour : ${text}`" @click="go">
    <v-icon :small="small" :left="small" :class="{ 'mr-2': !small }">mdi-chevron-left</v-icon>
    <span>{{ text }}</span>
  </v-btn>
</template>

<script>
import { previousMatches } from '@/router/history'

/**
 * "Up" navigation, driven by route metadata (`meta.parent`, `meta.backLabel`).
 *
 * Goes to the parent route; when the previous in-app page *is* that parent it
 * uses history back instead, so scroll position, filters and tabs are restored.
 * Falls back to the login page for signed-out visitors (legal pages) and to
 * `home` when a route declares no parent.
 */
export default {
  name: 'PageBack',
  props: {
    /** Explicit parent location, for pages whose parent is only known at runtime. */
    to: { type: [Object, String], default: null },
    /** Explicit label, overriding the route's `backLabel`. */
    label: { type: String, default: null },
    small: { type: Boolean, default: false },
  },
  computed: {
    loggedIn() {
      return !!this.$store.getters['settings/accessToken']
    },
    parent() {
      if (!this.loggedIn) return { name: 'login' }
      return this.to || this.$route.meta.parent || { name: 'home' }
    },
    text() {
      if (this.label) return this.label
      if (this.$route.meta.backLabel) return this.$route.meta.backLabel
      const parentRoute = this.$router.resolve(this.parent).route
      const isHome = parentRoute.name === 'home' || parentRoute.name === 'login'
      return (!isHome && parentRoute.meta.title) || 'Retour'
    },
  },
  methods: {
    go() {
      if (previousMatches(this.parent, this.$router)) this.$router.back()
      else this.$router.push(this.parent).catch(() => {})
    },
  },
}
</script>
